import { ProductV2 } from '@common'
import cx from 'classnames'
import Image from 'next/image'

import { DisplayAsset } from '../../../../../../../assetRendering/DisplayAsset'

import BrawlerBackground from 'assets/images/components/BrawlerCard/brawlercard-hero-bg.png'

import styles from './BrawlerHero.module.scss'

type Props = {
  product: ProductV2
  className?: string
}

export const BrawlerHero = ({ product, className }: Props) => {
  const item = product.contents.find((c) => c.product.itemType === 'Hero' || c.product.itemType === 'Skin')

  if (!item) {
    throw new Error('Invalid itemType')
  }

  return (
    <div className={cx(styles.BrawlerHero, className)} dir="ltr">
      <Image className={styles.Background} src={BrawlerBackground} alt="" fill />
      <div className={styles.Character}>
        <DisplayAsset content={item} preferAnimated gameId="brawlstars" />
      </div>
    </div>
  )
}
